import _regeneratorRuntime from 'babel-runtime/regenerator';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createActions2, _handleActions;

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(ensureType),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(saga);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Frames API.
import { createActions, handleActions } from 'redux-actions';
import update from 'immutability-helper';
import { put, select, takeEvery, take } from 'redux-saga/effects';
import { IIIF_RESOURCE_SUCCESS } from './iiif-resource';
import { RESOURCE_TYPE_MAP } from '../schema/presentation2';

var FRAME_CREATE = 'FRAME_CREATE';
var FRAME_DELETE = 'FRAME_DELETE';
var FRAME_SET_INITIAL_RESOURCE = 'FRAME_SET_INITIAL_RESOURCE';
var FRAME_GO_TO_RESOURCE = 'FRAME_GO_TO_RESOURCE';
var FRAME_GO_BACK = 'FRAME_GO_BACK';
var FRAME_GO_BACK_TO_TYPE = 'FRAME_GO_BACK_TO_TYPE';
var FRAME_GO_FORWARD = 'FRAME_GO_FORWARD';
var FRAME_ENABLE_EXTENSION = 'FRAME_ENABLE_EXTENSION';
var FRAME_CONFIGURE_EXTENSION = 'FRAME_CONFIGURE_EXTENSION';
var FRAME_DISABLE_EXTENSION = 'FRAME_DISABLE_EXTENSION';
var FRAME_NEXT_CANVAS = 'FRAME_NEXT_CANVAS';
var FRAME_PREVIOUS_CANVAS = 'FRAME_PREVIOUS_CANVAS';
var FRAME_FOCUS = 'FRAME_FOCUS';

var DEFAULT_STATE = {
  list: {},
  focusedFrame: null
};

var DEFAULT_FRAME_ID = 'default-frame';

var requireProps = function requireProps(requiredProps) {
  return function (retValue) {
    /* istanbul ignore next line */
    if (process.env.NODE_ENV === 'production') return retValue;

    requiredProps.forEach(function (prop) {
      if (!retValue[prop]) {
        throw new Error('Dev error: missing required prop ' + prop);
      }
    });

    return retValue;
  };
};

var _createActions = createActions((_createActions2 = {}, _createActions2[FRAME_CREATE] = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FRAME_ID;

  var resourceType = _ref.resourceType,
      resourceId = _ref.resourceId,
      config = _objectWithoutProperties(_ref, ['resourceType', 'resourceId']);

  return requireProps(['frameId'])({
    frameId: frameId,
    resourceType: resourceType,
    resourceId: resourceId,
    config: config
  });
}, _createActions2[FRAME_DELETE] = function (frameId) {
  return requireProps(['frameId'])({
    frameId: frameId
  });
}, _createActions2[FRAME_SET_INITIAL_RESOURCE] = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      resourceType = _ref2.resourceType,
      resourceId = _ref2.resourceId;

  var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FRAME_ID;
  return requireProps(['frameId', 'resourceId'])({
    frameId: frameId,
    resourceType: resourceType,
    resourceId: resourceId
  });
}, _createActions2[FRAME_GO_TO_RESOURCE] = function () {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      resourceType = _ref3.resourceType,
      resourceId = _ref3.resourceId,
      _ref3$smartJump = _ref3.smartJump,
      smartJump = _ref3$smartJump === undefined ? true : _ref3$smartJump;

  var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FRAME_ID;
  return requireProps(['resourceType', 'resourceId', 'frameId'])({
    frameId: frameId,
    resourceType: resourceType,
    resourceId: resourceId,
    smartJump: smartJump
  });
}, _createActions2[FRAME_GO_BACK] = function () {
  var frameId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FRAME_ID;
  return requireProps(['frameId'])({ frameId: frameId });
}, _createActions2[FRAME_GO_BACK_TO_TYPE] = function (resourceType) {
  var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FRAME_ID;
  return requireProps(['frameId', 'resourceType'])({
    frameId: frameId,
    resourceType: resourceType
  });
}, _createActions2[FRAME_GO_FORWARD] = function () {
  var frameId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FRAME_ID;
  return requireProps(['frameId'])({ frameId: frameId });
}, _createActions2[FRAME_ENABLE_EXTENSION] = function (extensionId, extensionConfig) {
  var frameId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_FRAME_ID;
  return requireProps(['extensionId', 'frameId'])({
    extensionId: extensionId,
    extensionConfig: extensionConfig,
    frameId: frameId
  });
}, _createActions2[FRAME_CONFIGURE_EXTENSION] = function (extensionId, extensionConfig) {
  var frameId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_FRAME_ID;
  var merge = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return requireProps(['extensionId', 'frameId'])({
    extensionId: extensionId,
    extensionConfig: extensionConfig,
    frameId: frameId,
    merge: merge
  });
}, _createActions2[FRAME_DISABLE_EXTENSION] = function (extensionId) {
  var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FRAME_ID;
  return requireProps(['extensionId', 'frameId'])({
    extensionId: extensionId,
    frameId: frameId
  });
}, _createActions2[FRAME_NEXT_CANVAS] = function () {
  var frameId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FRAME_ID;
  return requireProps(['frameId'])({
    frameId: frameId
  });
}, _createActions2[FRAME_PREVIOUS_CANVAS] = function () {
  var frameId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FRAME_ID;
  return requireProps(['frameId'])({
    frameId: frameId
  });
}, _createActions2[FRAME_FOCUS] = function () {
  var frameId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FRAME_ID;
  return requireProps(['frameId'])({
    frameId: frameId
  });
}, _createActions2)),
    frameCreate = _createActions.frameCreate,
    frameDelete = _createActions.frameDelete,
    frameSetInitialResource = _createActions.frameSetInitialResource,
    frameGoToResource = _createActions.frameGoToResource,
    frameGoBack = _createActions.frameGoBack,
    frameGoBackToType = _createActions.frameGoBackToType,
    frameGoForward = _createActions.frameGoForward,
    frameEnableExtension = _createActions.frameEnableExtension,
    frameConfigureExtension = _createActions.frameConfigureExtension,
    frameDisableExtension = _createActions.frameDisableExtension,
    frameNextCanvas = _createActions.frameNextCanvas,
    framePreviousCanvas = _createActions.framePreviousCanvas,
    frameFocus = _createActions.frameFocus;

var reducer = handleActions((_handleActions = {}, _handleActions[frameCreate] = function (state, _ref4) {
  var _list;

  var _ref4$payload = _ref4.payload,
      frameId = _ref4$payload.frameId,
      resourceType = _ref4$payload.resourceType,
      resourceId = _ref4$payload.resourceId,
      config = _ref4$payload.config;
  return update(state, {
    focusedFrame: { $set: frameId },
    list: (_list = {}, _list[frameId] = {
      $set: {
        id: frameId,
        current: 0,
        path: resourceId && resourceType ? [{ id: resourceId, schema: resourceType }] : [],
        enabledExtensions: [],
        extensions: {},
        config: config
      }
    }, _list)
  });
}, _handleActions[frameDelete] = function (state, _ref5) {
  var frameId = _ref5.payload.frameId;
  return update(state, {
    focusedFrame: {
      $apply: function $apply(focusedFrame) {
        return focusedFrame === frameId ? null : focusedFrame;
      }
    },
    list: {
      $apply: function $apply(list) {
        list[frameId] = null;
        delete list[frameId];
        return _extends({}, list);
      }
    }
  });
}, _handleActions[frameSetInitialResource] = function (state, _ref6) {
  var _list2;

  var _ref6$payload = _ref6.payload,
      frameId = _ref6$payload.frameId,
      resourceType = _ref6$payload.resourceType,
      resourceId = _ref6$payload.resourceId;
  return update(state, {
    list: (_list2 = {}, _list2[frameId] = {
      current: { $set: 0 },
      path: { $set: [{ id: resourceId, schema: resourceType }] }
    }, _list2)
  });
}, _handleActions[frameGoToResource] = function (state, _ref7) {
  var _list3;

  var _ref7$payload = _ref7.payload,
      frameId = _ref7$payload.frameId,
      resourceType = _ref7$payload.resourceType,
      resourceId = _ref7$payload.resourceId,
      smartJump = _ref7$payload.smartJump;
  return update(state, {
    list: (_list3 = {}, _list3[frameId] = {
      $apply: function $apply(frame) {
        // If element is already in history, jump to it instead.
        if (smartJump && frame.path.filter(function (path) {
          return path.id === resourceId;
        }).length) {
          var ids = frame.path.reduce(function (acc, next) {
            acc.push(next.id);
            return acc;
          }, []);

          return update(frame, {
            current: { $set: ids.indexOf(resourceId) }
          });
        }

        // The same as set initial resource.
        if (frame.path.length === 0) {
          return update(frame, {
            current: { $set: 0 },
            path: { $set: [{ id: resourceId, schema: resourceType }] }
          });
        }

        // If not chop of lost history
        var current = state.list[frameId].current || 0;
        var newCurrent = current + 1;
        var newPath = frame.path.slice(0, newCurrent);
        newPath.push({ id: resourceId, schema: resourceType });
        return update(frame, {
          current: { $set: newCurrent },
          path: { $set: newPath }
        });
      }
    }, _list3)
  });
}, _handleActions[frameGoBack] = function (state, _ref8) {
  var _list4;

  var frameId = _ref8.payload.frameId;
  return update(state, {
    list: (_list4 = {}, _list4[frameId] = {
      current: {
        $apply: function $apply(current) {
          return current === 0 ? 0 : current - 1;
        }
      }
    }, _list4)
  });
}, _handleActions[frameGoForward] = function (state, _ref9) {
  var _list5;

  var frameId = _ref9.payload.frameId;
  return update(state, {
    list: (_list5 = {}, _list5[frameId] = {
      $apply: function $apply(frame) {
        if (frame.path.length - 1 <= frame.current) {
          return frame;
        }
        return update(frame, {
          current: { $set: frame.current + 1 }
        });
      }
    }, _list5)
  });
}, _handleActions[frameEnableExtension] = function (state, _ref10) {
  var _extensions, _list6;

  var _ref10$payload = _ref10.payload,
      extensionId = _ref10$payload.extensionId,
      extensionConfig = _ref10$payload.extensionConfig,
      frameId = _ref10$payload.frameId;
  return update(state, {
    list: (_list6 = {}, _list6[frameId] = {
      enabledExtensions: {
        $apply: function $apply(enabledExtensions) {
          return enabledExtensions.indexOf(extensionId) === -1 ? [].concat(enabledExtensions, [extensionId]) : enabledExtensions;
        }
      },
      extensions: (_extensions = {}, _extensions[extensionId] = { $set: extensionConfig }, _extensions)
    }, _list6)
  });
}, _handleActions[frameConfigureExtension] = function (state, _ref11) {
  var _extensions2, _list7;

  var _ref11$payload = _ref11.payload,
      extensionId = _ref11$payload.extensionId,
      extensionConfig = _ref11$payload.extensionConfig,
      frameId = _ref11$payload.frameId,
      merge = _ref11$payload.merge;
  return update(state, {
    list: (_list7 = {}, _list7[frameId] = {
      extensions: (_extensions2 = {}, _extensions2[extensionId] = merge ? { $merge: extensionConfig } : { $set: extensionConfig }, _extensions2)
    }, _list7)
  });
}, _handleActions[frameDisableExtension] = function (state, _ref12) {
  var _list8;

  var _ref12$payload = _ref12.payload,
      extensionId = _ref12$payload.extensionId,
      frameId = _ref12$payload.frameId;
  return update(state, {
    list: (_list8 = {}, _list8[frameId] = {
      enabledExtensions: {
        $apply: function $apply(enabledExtensions) {
          return enabledExtensions.reduce(function (acc, ext) {
            if (ext !== extensionId) {
              acc.push(ext);
            }
            return acc;
          }, []);
        }
      }
    }, _list8)
  });
}, _handleActions[frameFocus] = function (state, _ref13) {
  var frameId = _ref13.payload.frameId;
  return update(state, {
    focusedFrame: { $set: frameId }
  });
}, _handleActions), DEFAULT_STATE);

/**
 * Ensure type saga.
 *
 * This is required if an unknown resource type is selected. It will usually
 * be imported as "unknown" and then selected. Its likely that at this point
 * no one knows what the resource type is.
 *
 * This saga waits for the resource type to be known, from a subset of
 * dereferenced types and will re-send the selectResource with the correct type.
 *
 * This is especially useful for importing user input, without them providing
 * a resource type.
 */
function ensureType(_ref14) {
  var _ref14$payload = _ref14.payload,
      frameId = _ref14$payload.frameId,
      resourceId = _ref14$payload.resourceId,
      resourceType = _ref14$payload.resourceType;

  var resourceInState, state, _ref15, newResourceId;

  return _regeneratorRuntime.wrap(function ensureType$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(resourceId && !resourceType)) {
            _context.next = 18;
            break;
          }

          resourceInState = function resourceInState(currentState) {
            return currentState.resources.collections[resourceId] || currentState.resources.manifests[resourceId];
          }; // @todo more?

          _context.next = 4;
          return select(resourceInState);

        case 4:
          state = _context.sent;

        case 5:
          if (state) {
            _context.next = 16;
            break;
          }

          _context.next = 8;
          return take(IIIF_RESOURCE_SUCCESS);

        case 8:
          _ref15 = _context.sent;
          newResourceId = _ref15.payload.resourceId;

          if (!(resourceId === newResourceId)) {
            _context.next = 14;
            break;
          }

          _context.next = 13;
          return select(resourceInState);

        case 13:
          state = _context.sent;

        case 14:
          _context.next = 5;
          break;

        case 16:
          _context.next = 18;
          return put(frameSetInitialResource({
            resourceId: resourceId,
            resourceType: RESOURCE_TYPE_MAP[state.type || state['@type']]
          }, frameId));

        case 18:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function saga() {
  return _regeneratorRuntime.wrap(function saga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(FRAME_SET_INITIAL_RESOURCE, ensureType);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

//function* saga() {
// frameGoBackToType -> go to correct resource.
// frameNextCanvas -> go to next canvas.
// framePreviousCanvas -> go to previous canvas.
//}

export {
// constants.
FRAME_CREATE, FRAME_DELETE, FRAME_SET_INITIAL_RESOURCE, FRAME_GO_TO_RESOURCE, FRAME_GO_BACK, FRAME_GO_BACK_TO_TYPE, FRAME_GO_FORWARD, FRAME_ENABLE_EXTENSION, FRAME_CONFIGURE_EXTENSION, FRAME_DISABLE_EXTENSION, FRAME_NEXT_CANVAS, FRAME_PREVIOUS_CANVAS,
// actions.
frameCreate, frameDelete, frameSetInitialResource, frameGoToResource, frameGoBack, frameGoBackToType, frameGoForward, frameEnableExtension, frameConfigureExtension, frameDisableExtension, frameNextCanvas, framePreviousCanvas, frameFocus,
// redux.
saga, reducer, DEFAULT_STATE, DEFAULT_FRAME_ID };